// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_sn-5";
export var filledCircle = "_sn-4";
export var historyEntry = "_sn-3";
export var messageSideLeft = "_sn-1";
export var messageSideRight = "_sn-2";
export var orderTrackingCarouselWrapper = "_sn-6";
export var orderTrackingInfoContainer = "_sn-0";